/* @flow */
import { IdentityVerification } from 'payments/constants/CopyConstants';
import BoxBody from 'components/BoxBody.jsx';
import cx from 'classnames';
import Dialog from 'components/Dialog.jsx';
import IdentityVerificationView from './IdentityVerificationView.jsx';
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/IdentityVerificationModal.scss';

const IdentityVerificationModal = React.createClass({
  onVerified() {
    ToastActions.showSuccessToast('Your account is now verified.');
    this.props.onRequestHide();
  },

  render() {
    const { className, ...rest } = this.props;

    return (
      <Dialog
        eventScreenName="IdentityVerificationModal"
        {...rest}
        size="large"
        className={cx('IdentityVerificationModal', className)}>
        <BoxBody>
          <TitleHeader title={IdentityVerification.title} subtext={IdentityVerification.subtext} />
          <IdentityVerificationView onVerified={this.onVerified} />
        </BoxBody>
      </Dialog>
    );
  },
});

export default IdentityVerificationModal;



// WEBPACK FOOTER //
// ./src/payments/components/IdentityVerificationModal.jsx